import React, { useEffect, useState, useRef } from "react";
import { IonChip, IonLabel } from "@ionic/react";
import { Rider } from "../../models";
import { CreateEntryInterface } from "../../utilities/eventEntry/CreateEventEntryUtils";

interface _Props {
    preSelectedRider?: Rider | null | undefined;
    entryInfo: CreateEntryInterface;
    onSelect: Function;
}

const SelectRiderForEventClass: React.FC<_Props> = ({ entryInfo, preSelectedRider, onSelect }) => {
    const [selectedRider, setSelectedRider] = useState<Rider | null | undefined>();
    const [rider1, setRider1] = useState<Rider | null | undefined>();
    const [rider2, setRider2] = useState<Rider | null | undefined>();
    const hasInitialized = useRef(false);

    useEffect(() => {
        function getRiderOptions(entryInfo: CreateEntryInterface) {
            // Set rider 1 and rider 2
            const rider1Option = entryInfo.currentRider || null;
            const rider2Option = entryInfo.currentRider2 || null;
            setRider1(rider1Option);
            setRider2(rider2Option);

            // Set the selected option - auto-select Rider 1 if no preSelectedRider
            if (preSelectedRider) {
                setSelectedRider(preSelectedRider);
                hasInitialized.current = true;
            } else if (rider1Option && !hasInitialized.current) {
                // Auto-select Rider 1 by default when first initializing
                setSelectedRider(rider1Option);
                onSelect(rider1Option);
                hasInitialized.current = true;
            }
        }

        if (entryInfo) getRiderOptions(entryInfo);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [entryInfo, preSelectedRider]);

    const handleChipClick = (rider: Rider | null | undefined) => {
        if (!rider) return;

        // Toggle selection: if clicking the already selected rider, switch to the other rider
        // Otherwise, select the clicked rider
        if (selectedRider?.id === rider.id) {
            // If clicking the selected rider, switch to the other one
            // If Rider 1 is selected and clicked, switch to Rider 2 (if available), otherwise stay on Rider 1
            // If Rider 2 is selected and clicked, switch to Rider 1
            if (rider.id === rider1?.id && rider2) {
                setSelectedRider(rider2);
                onSelect(rider2);
            } else if (rider.id === rider2?.id && rider1) {
                setSelectedRider(rider1);
                onSelect(rider1);
            }
        } else {
            // Select the clicked rider
            setSelectedRider(rider);
            onSelect(rider);
        }
    };

    return (
        <>
            <style>{`
                .rider-chips-selector {
                    display: inline-flex;
                    gap: 4px;
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: flex-start;
                }
                @media (min-width: 768px) {
                    .rider-chips-selector {
                        justify-content: center;
                    }
                }
            `}</style>
            {rider1 || rider2 ? (
                <div className="rider-chips-selector">
                    {rider1 && (
                        <IonChip
                            onClick={() => handleChipClick(rider1)}
                            style={{
                                backgroundColor: selectedRider?.id === rider1.id ? "var(--ion-color-primary)" : "rgba(58, 68, 84, 0.4)",
                                color: "white",
                                cursor: "pointer",
                                opacity: selectedRider?.id === rider1.id ? 1 : 1,
                                transition: "opacity 0.2s",
                                height: "20px",
                                fontSize: "12px",
                                padding: "0 6px",
                                margin: "0",
                            }}>
                            <IonLabel style={{ color: "white", fontSize: "12px", padding: "0", margin: "0" }}>Rider 1 - {rider1.name}</IonLabel>
                        </IonChip>
                    )}
                    {rider2 && (
                        <IonChip
                            onClick={() => handleChipClick(rider2)}
                            style={{
                                backgroundColor: selectedRider?.id === rider2.id ? "var(--ion-color-info)" : "rgba(115, 164, 211, 0.4)",
                                color: "white",
                                cursor: "pointer",
                                opacity: selectedRider?.id === rider2.id ? 1 : 1,
                                transition: "opacity 0.2s",
                                height: "20px",
                                fontSize: "12px",
                                padding: "0 6px",
                                margin: "0",
                            }}>
                            <IonLabel style={{ color: "white", fontSize: "12px", padding: "0", margin: "0" }}>Rider 2 - {rider2.name}</IonLabel>
                        </IonChip>
                    )}
                </div>
            ) : (
                <p>No riders selected</p>
            )}
        </>
    );
};

export default SelectRiderForEventClass;
